import useSWR from 'swr';
import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import Link from 'next/link';
import Image from 'next/future/image';
import Loading from '@/components/Loading/Loading';
import Slider from '@/components/slider/Slider';
import ProductCard from '../category/ProductCard';
import { defaultBreakpoints } from '@/lib/common/breakpoints';
import Section from '../commons/Section';
import { objectToUrlParams } from '../collections-v2/common/YouMayAlsoLike/helpers';
import plus_black from '@/public/icons/homepage/plus.svg';

interface MoreFromBrandProps {
  sectionClasses?: string;
  brand: string;
  category: string;
}

const ProductCarousel = ({ brand }: { brand: string }) => {
  const qs = objectToUrlParams({
    brand,
  });

  const { data } = useSWR<SearchOffers[] | null>(
    () => `/api/collections/brand-search-offers?${qs}`,
  );

  if (data == null) return <Loading />;

  if (data.length < 10) return null; // Do not display the Carousel if we have less than 10 offers

  const sectionTitle = `More From ${brand}`;

  return (
    <Section>
      <h2 className="flex items-center text-lg font-semibold md:text-xl">
        {sectionTitle}
      </h2>
      <div className="relative mt-6">
        <Slider breakpoints={defaultBreakpoints} speed={300}>
          {data.map((offer) => (
            <ProductCard offer={offer} />
          ))}

          <div className="h-full w-full rounded-md bg-teal-500 p-5 text-gray-700">
            <Link href={`/collections/brand/${brand}`} passHref>
              <a className="flex h-full w-full flex-col items-center justify-center duration-500 ease-in-out will-change-contents hover:scale-105">
                <div className="block h-6 w-6 xs:h-7 xs:w-7">
                  <Image
                    src={plus_black}
                    alt={`${brand}-link`}
                    className="w-full"
                  />
                </div>
                <p className="mt-4 text-center text-xs font-bold !leading-4 xxs:text-sm xs:!leading-5 sm:text-base">
                  More from {brand}
                </p>
              </a>
            </Link>
          </div>
        </Slider>
      </div>
    </Section>
  );
};

export default function MoreFromBrand(props: MoreFromBrandProps) {
  const { brand, category } = props;
  const shouldHideCarousel = [
    'Smartphones',
    'Smartwatches',
    'Laptops',
    'Tablets',
  ].includes(category);

  if (!brand || shouldHideCarousel) return null;

  return <ProductCarousel brand={brand} />;
}
